module.exports = ".container {\n  text-align: center;\n}\n.container img {\n  max-width: 700px;\n  width: 70%;\n}\n.container h1,\n.container h3 {\n  color: #999;\n}\n/*# sourceMappingURL=src/app/not-found/not-found.component.css.map */"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.styl
// module id = ./src/app/not-found/not-found.component.styl
// module chunks = main